import mapboxgl from "mapbox-gl";
import StylesControl from "mapbox-gl-controls/lib/styles";
import CompassControl from 'mapbox-gl-controls/lib/compass';
import ZoomControl from 'mapbox-gl-controls/lib/zoom';
import "mapbox-gl/dist/mapbox-gl.css";
import "mapbox-gl-controls/theme.css";
import atributs from "../assets/atribut";

export default function createMap() {
	const map = new mapboxgl.Map({
		container: "map",
		minZoom: 2,
		maxZoom: 17.99,
		hash: true,
		style: "https://geoserveis.icgc.cat/contextmaps/hibrid.json",
		center: [1.88979, 41.69589],
		zoom: 13.61,
		attributionControl: false,
		preserveDrawingBuffer: true
	});

	map.addControl(new ZoomControl(), 'top-right');

	map.addControl(new mapboxgl.AttributionControl({
		compact: true
	}));

	map.on('mousemove', "cobertes", function (e) {
		var features = map.queryRenderedFeatures(e.point);
		const atribu = atributs.find(element => element.nivell_2 === features[0].properties.nivell_2);
		document.getElementById('features').innerHTML = `${atribu.nivell_2} ${atribu.categoria}`;
	});
	 
	map.on('load', function () {
		map.addSource("cobertes", {
            "type": "vector",
            "url": "https://tilemaps.icgc.cat/tileserver/cobertes_tilejson.json",
            "maxzoom": 16
		});
		
		map.addLayer({
			"id": "cobertes",
			"type": "fill",
			"source": "cobertes",
			"source-layer": "cobertes",
			"maxzoom": 18,
			"paint": {
				"fill-opacity": [
					'interpolate',
					['exponential', 0.5],
					['zoom'],
					13.5,
					1,
					18,
					0.4
				],
				"fill-outline-color": "rgba(0,0, 0, 0)",
				"fill-color": [
					"interpolate",
					[
						"cubic-bezier",
						0.5,
						1,
						1,
						1
					],
					[
						"get",
						"nivell_2"
					],
					0,
					"#ffffff",
					111,
					"#ffff00",
					112,
					"#ccff33",
					113,
					"#af5b15",
					114,
					"#808000",
					115,
					"#cdcd00",
					116,
					"#ffffcc",
					221,
					"#33cc33",
					222,
					"#66ff33",
					223,
					"#689018",
					224,
					"#967d5f",
					225,
					"#19e61e",
					226,
					"#b4ff9b",
					227,
					"#aaa500",
					228,
					"#c3c3a0",
					229,
					"#00ff9b",
					230,
					"#ff9632",
					231,
					"#282828",
					232,
					"#79797a",
					233,
					"#f5df78",
					234,
					"#3296ff",
					341,
					"#ff007d",
					342,
					"#ff53cd",
					343,
					"#ffa4e2",
					344,
					"#ffc8e2",
					345,
					"#ffb4b4",
					346,
					"#0f3700",
					347,
					"#730055",
					348,
					"#6200c4",
					349,
					"#4a9595",
					350,
					"#ff00f0",
					351,
					"#adaaca",
					352,
					"#ffe6e6",
					353,
					"#67629a",
					354,
					"#4a466e",
					355,
					"#2f2d46",
					461,
					"#6f6fff",
					462,
					"#0000dc",
					463,
					"#000064",
					464,
					"#185f94",
					465,
					"#12466d",
					466,
					"#000080"
				]
			}
		}, "waterway-name");

		/*map.addSource('wms-cobertes-sol', {
		'type': 'raster',
		'tiles': [
			'https://geoserveis.icgc.cat/servei/catalunya/cobertes-sol/wms?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&transparent=true&width=512&height=512&layers=cobertes_2018'
		],
		'tileSize': 512
		});
		map.addLayer(
		{
		'id': 'cobertes_2018',
		'type': 'raster',
		'source': 'wms-cobertes-sol',
		'paint': {
			"raster-opacity": [
				'interpolate',
				['exponential', 0.5],
				['zoom'],
				13.5,
				1,
				18,
				0.4
			]
		}
		},
		'waterway-name'
		);
		*/
	});

	return map;
}
